import { useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Spinner from "../../../assets/icons/Spinner";
import Message from "../../../i18n/Message";
import label from "../../../i18n/label";
import TemplateTile from "./TemplateTile";
import { loadTemplates } from "../store/builderActionCreators";
import { builderSelectors } from "../store/builderReducer";
import NewWorkspaceLayout from "../../workspace/layout/NewWorkspaceLayout";
import { linkToBuilder } from "../../../routes";

import "./TemplateCataloguePage.scss";

const TemplateCataloguePage = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { workspaceId } = useParams();

  const templates = useSelector(builderSelectors.getTemplates);
  const loading = useSelector(builderSelectors.isTemplatesLoading);
  const error = useSelector(builderSelectors.getTemplatesError);

  const [searchInput, setSearchInput] = useState("");

  // Load templates on mount
  useEffect(() => {
    dispatch(loadTemplates());
  }, [dispatch]);

  // Filter templates by search query (client-side)
  const filteredTemplates = useMemo(() => {
    if (!templates) return null;
    if (!searchInput.trim()) return templates;

    const query = searchInput.toLowerCase().trim();
    return templates.filter((t) =>
      t.name?.toLowerCase().includes(query)
    );
  }, [templates, searchInput]);

  return (
    <NewWorkspaceLayout contentPanelClassName="template_catalogue_page">
      <div className="breadcrumbs">
        <Link to={linkToBuilder(workspaceId)}>
          <Message id="app_builder_projects_title" />
        </Link>
        <span className="separator">/</span>
        <span className="current">
          <Message id="template_catalogue" />
        </span>
      </div>

      <h1>
        <Message id="template_catalogue" />
      </h1>

      <div className="filters_panel">
        <input
          type="text"
          className="search_input"
          placeholder={label(intl, "search_templates", "Search templates...")}
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
      </div>

      <div className="body_content">
        {loading && !templates && <Spinner />}

        {error && (
          <div className="error_state">
            <Message id="error_loading_templates" />
          </div>
        )}

        {filteredTemplates && filteredTemplates.length === 0 && (
          <div className="empty_state">
            <Message id="no_templates_found" />
          </div>
        )}

        {filteredTemplates && filteredTemplates.length > 0 && (
          <div className="template_grid">
            {filteredTemplates.map((template) => (
              <TemplateTile
                key={template.uid}
                template={template}
                workspaceId={workspaceId}
              />
            ))}
          </div>
        )}
      </div>
    </NewWorkspaceLayout>
  );
};

export default TemplateCataloguePage;
